module.exports = __webpack_public_path__ + "static/media/finger.8ff97f3f.png";